import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./assets/styles/main.scss";

import router from "./router";
import store from "./store";

require("@/store/subscriber");

require("./mixin.js");
require("./axios.js");
require('./filters.js');

// Import and register permission mixin globally
import permissionMixin from "@/mixins/permissionMixin";
Vue.mixin(permissionMixin);

// Back to a list returns to the same page / filters instead of page 1
import listStateMixin from "@/mixins/listStateMixin";
Vue.mixin(listStateMixin);

Vue.config.productionTip = false;

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import CryptoJS from "crypto-js";
window.CryptoJS = CryptoJS;

// Import and register Laravel Echo globally (same as Mehfil)
import echo from "./plugins/echo";
Vue.prototype.$echo = echo;

// Global $toast helper (Vuetify snackbars, rendered by <app-toast> in App.vue)
import toast from "./plugins/toast";
Vue.use(toast);


// Media base URL for files stored on the Vultr bucket (used via this.mediaUrl)
store.dispatch("settings/setMediaUrl", process.env.VUE_APP_MEDIA_BASE_URL || "");
store.dispatch("settings/setBaseUrl", process.env.VUE_APP_API_URL || "");

store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
